import React from 'react';
import { Mui } from '@osu/react-ui';

/**
 * SelectedStudentCard Component
 * Displays the currently selected student information
 */
function SelectedStudentCard({
  selectedStudent,
  hasSearched,
  searchQuery
}) {
  // Only show when there's a selected student, no current search results, and search is empty
  if (!selectedStudent || hasSearched || (searchQuery && searchQuery.trim().length > 0)) {
    return null;
  }

  return (
    <Mui.Paper 
      elevation={2} 
      sx={{ 
        p: 2, 
        mb: 2, 
        backgroundColor: '#e3f2fd',
        border: '2px solid #1976d2'
      }}
    >
      <Mui.Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
        Selected Student
      </Mui.Typography>
      
      <Mui.Typography variant="body2">
        <strong>Name:</strong> {selectedStudent.name}
      </Mui.Typography>
      
      <Mui.Typography variant="body2">
        <strong>Email:</strong> {selectedStudent.email || 'No email available'}
      </Mui.Typography>
      
      <Mui.Typography variant="body2">
        <strong>ID:</strong> {selectedStudent.id}
      </Mui.Typography>
      
      <Mui.Typography variant="body2">
        <strong>Programs:</strong> {selectedStudent.programs?.join(', ') || 'No programs'}
      </Mui.Typography>
    </Mui.Paper>
  );
}

export default SelectedStudentCard;